export enum DeviceModel {
	AD4D = 'AD4D',
	AD4Q = 'AD4Q',
	AD600 = 'AD600',
	ADTD = 'ADTD',
	ADTQ = 'ADTQ',
	ANIUSB = 'ANIUSB-MATRIX',
	DCA901 = 'DCA901',
	HUDDLYCREW = 'Huddly Crew',
	HUDDLYIQ = 'Huddly IQ',
	HUDDLYL1 = 'Huddly L1',
	IMXBP = 'IMXBP',
	IMXCOMPUTE = 'IMX-Compute',
	IMXCOMPUTECONSOLE = 'IMX-Compute Console',
	IMXTP10 = 'IMXTP10',
	IMXROOM = 'IMX-Room',
	JINJICH2 = 'SBC250',
	JINJICH4 = 'SBC450',
	JINJICH8 = 'SBC850',
	MCR = 'ANX4',
	MV7I = 'MV7i',
	MXA310 = 'MXA310',
	MXA320 = 'MXA320',
	MXA7102FT = 'MXA710-2FT',
	MXA7104FT = 'MXA710-4FT',
	MXA901R = 'MXA901-R',
	MXA901S = 'MXA901-S',
	MXA902S = 'MXA902-S',
	MXA910 = 'MXA910',
	MXA920R = 'MXA920-R',
	MXA920S = 'MXA920-S',
	MXA925R = 'MXA925-R',
	MXA925S = 'MXA925-S',
	MXAMUTE = 'MXA-MUTE',
	MXN5C = 'MXN5-C',
	MXN6 = 'MXN-6',
	MXNAMP = 'MXN-AMP',
	MXW1X = 'MXW1X',
	MXW2X = 'MXW2X',
	MXW6X = 'MXW6X',
	MXW8X = 'MXW8X',
	MXWAPX = 'MXWAPX',
	MXWAPXD2 = 'MXWAPXD2',
	MXWNDX2 = 'MXWNDX2',
	MXWNDX4 = 'MXWNDX4',
	MXWNDX4G = 'MXWNDX4G',
	MXWNDX8 = 'MXWNDX8',
	MXWNDX8G = 'MXWNDX8G',
	P300 = 'P300',
	P600 = 'P600',
	QLXD = 'QLXD4',
	UCWALL = 'UC-WALL',
	ULXD1RX = 'ULXD4',
	ULXD4Q = 'ULXD4Q',
	ULXD6TX = 'ULXD6',
	ULXD8TX = 'ULXD8',
	UNKNOWN = 'UNKNOWN'
}
